import { useAppState } from '../hooks'

// the asterisk in this label refers to SmsConsentDisclosure, so only use it on screens
// that render the disclosure alongside the phone input
export const SMS_CONSENT_PHONE_LABEL = 'Mobile Phone (must validate via SMS)*'

type SmsConsentDisclosureProps = {
  /** name of the button that submits the phone number, e.g. "Check Eligibility" */
  actionLabel: string
}

export const SmsConsentDisclosure = ({ actionLabel }: SmsConsentDisclosureProps) => {
  const { tenant } = useAppState()

  return (
    <p className="form-text text-muted m-0 mb-4 fst-italic">
      * By providing this mobile phone number and selecting "{actionLabel}", you consent to receive text
      messages from {tenant.config?.name}, or its service providers acting on its behalf, for security,
      authentication, fraud prevention, and identity verification purposes, including one-time passcodes
      and secure links related to your loan application. Message and data rates may apply.
    </p>
  )
}
